import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import HttpBackend from "i18next-http-backend";

i18n
  .use(HttpBackend)              // load JSON files
  .use(LanguageDetector)         // detect language
  .use(initReactI18next)         // pass i18n to react
  .init({
    fallbackLng: "en",
    supportedLngs: ["en", "de", "es", "fr", "it"],
    load: "languageOnly",        // e.g., "en" instead of "en-US"
    debug: false,
    interpolation: {
      escapeValue: false,
    },
    ns: ["common"],
    defaultNS: "common",
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
      lookupLocalStorage: "i18nextLng",
    },
  });

export default i18n;
